// ============================================
// Shopify Sepete Ekleme (AJAX)
// ============================================
function addToCart(variantId, btn) {
  const original = btn.textContent;
  btn.textContent = 'Ekleniyor...';
  btn.disabled = true;

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: 1 })
  })
    .then(res => {
      if (!res.ok) throw new Error();
      return res.json();
    })
    .then(() => {
      btn.textContent = '✓ Sepete Eklendi';
      btn.style.background = 'linear-gradient(135deg,#16a34a,#22c55e)';
      updateCartCount();
      setTimeout(() => {
        btn.textContent = original;
        btn.style.background = '';
        btn.disabled = false;
      }, 2000);
    })
    .catch(() => {
      btn.textContent = 'Hata oluştu!';
      btn.style.background = '#ef4444';
      setTimeout(() => {
        btn.textContent = original;
        btn.style.background = '';
        btn.disabled = false;
      }, 2000);
    });
}

function updateCartCount() {
  fetch('/cart.js')
    .then(r => r.json())
    .then(cart => {
      const badge = document.querySelector('.cart-count');
      if (cart.item_count > 0) {
        if (badge) {
          badge.textContent = cart.item_count;
        } else {
          const cartLink = document.querySelector('.icon-btn[href*="cart"]');
          if (cartLink) {
            const span = document.createElement('span');
            span.className = 'cart-count';
            span.textContent = cart.item_count;
            cartLink.appendChild(span);
          }
        }
      }
    });
}

// ============================================
// Slider
// ============================================
(function initSlider() {
  document.querySelectorAll('.slider').forEach(slider => {
    const track = slider.querySelector('.slider-track');
    const slides = slider.querySelectorAll('.slide');
    const dots = slider.querySelectorAll('.slider-dot');
    const prev = slider.querySelector('.slider-arrow.prev');
    const next = slider.querySelector('.slider-arrow.next');

    if (slides.length <= 1) return;

    let current = 0;
    let timer = null;
    const autoplay = slider.dataset.autoplay === 'true';
    const interval = parseInt(slider.dataset.interval, 10) || 5000;

    function goTo(index) {
      current = (index + slides.length) % slides.length;
      track.style.transform = `translateX(-${current * 100}%)`;
      dots.forEach((d, i) => d.classList.toggle('active', i === current));
    }

    function startAuto() {
      if (!autoplay) return;
      stopAuto();
      timer = setInterval(() => goTo(current + 1), interval);
    }

    function stopAuto() {
      if (timer) { clearInterval(timer); timer = null; }
    }

    dots.forEach((dot, i) => {
      dot.addEventListener('click', () => { goTo(i); startAuto(); });
    });

    if (prev) prev.addEventListener('click', () => { goTo(current - 1); startAuto(); });
    if (next) next.addEventListener('click', () => { goTo(current + 1); startAuto(); });

    // Pause on hover
    slider.addEventListener('mouseenter', stopAuto);
    slider.addEventListener('mouseleave', startAuto);

    // Touch swipe
    let startX = 0;
    slider.addEventListener('touchstart', e => {
      startX = e.touches[0].clientX;
      stopAuto();
    }, { passive: true });
    slider.addEventListener('touchend', e => {
      const dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 50) goTo(current + (dx < 0 ? 1 : -1));
      startAuto();
    });

    startAuto();
  });
})();

// ============================================
// Product Detail: Thumbnail switcher
// ============================================
(function initPdThumbs() {
  document.querySelectorAll('.thumb-img').forEach(thumb => {
    thumb.addEventListener('click', () => {
      const main = document.querySelector('.pd-main-img');
      if (!main) return;
      const src = thumb.dataset.full || thumb.src;
      main.src = src;
      document.querySelectorAll('.thumb-img').forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');
    });
  });
})();
